import { ref } from 'vue'

import { useWebSiteStore } from '@/stores/web-site.store'
import { useAccountingStore } from '@/stores/accounting.store'

export const useDocumentRow = () => {
  const webSiteStore = useWebSiteStore()
  const accountingStore = useAccountingStore()

  const alwaysEnabledFields = ['document_row_type', 'description', 'notes', 'date']

  const lastDocumentRowType = ref(null)

  const onDocumentRowUpdated = (e) => {
    lastDocumentRowType.value = null
    if (e.data.document_row_type) {
      lastDocumentRowType.value = e.data.document_row_type
    }
  }

  const onDocumentRowEditorPreparing = (e, editors, documentRowType, form) => {
    if (e.parentType === 'dataRow' && e.dataField === 'document_row_type') {
      e.editorOptions.readOnly = !!e.row.data?.id
      const defaultValueChangeHandler = e.editorOptions.onValueChanged
      e.editorOptions.onValueChanged = (args) => {
        documentRowType.value = args.value
        defaultValueChangeHandler(args)
        form.value?.repaint()
      }
    }
    if (e.parentType === 'dataRow' && !!e.dataField) {
      if (e.dataField === 'listing_item') {
        e.editorOptions.disabled = e.row?.data?.document_row_type !== webSiteStore.documentRowTypeEnum.LISTING_ITEM
      } else if (e.dataField === 'budget_document_row_category_ref') {
        e.editorOptions.disabled = e.row?.data?.document_row_type !== webSiteStore.documentRowTypeEnum.EXTRA
      } else if (e.dataField === 'unit_of_measure_ref') {
        e.editorOptions.readOnly = e.row?.data?.document_row_type === webSiteStore.documentRowTypeEnum.LISTING_ITEM
        e.editorOptions.disabled = e.row?.data?.document_row_type === webSiteStore.documentRowTypeEnum.COMMENT
      } else {
        e.editorOptions.disabled = e.row?.data?.document_row_type === webSiteStore.documentRowTypeEnum.COMMENT && !alwaysEnabledFields.includes(e.dataField)
      }
    }
  }

  const onDocumentRowInitNewRow = (e, discount, documentRowType) => {
    e.data.quantity = 1
    e.data.price = 0
    e.data.cost_valorization = accountingStore.costValorizationsEnum.PRICE
    e.data.document_row_type = documentRowType.value = lastDocumentRowType?.value || e.data?.document_row_type || webSiteStore.getDefaultDocumentRowType()

    if (e.data.document_row_type !== webSiteStore.documentRowTypeEnum.COMMENT) {
      e.data.discount = discount
    }
  }

  return {
    lastDocumentRowType,
    onDocumentRowUpdated,
    onDocumentRowInitNewRow,
    onDocumentRowEditorPreparing
  }
}

// A comment row has no pricing: leave those cells empty instead of showing zeros.
const COMMENT_ROW_PRICING_FIELDS = Object.freeze([
  'quantity',
  'unit_of_measure_ref',
  'amount_per_unit',
  'price',
  'cost',
  'cost_valorization',
  'discount',
  'charge_percentage',
  'vat_type_ref',
  'total_no_vat',
  'total_vat',
])

export const useCommentRowCells = () => {
  const webSiteStore = useWebSiteStore()

  const isCommentRow = (row) => row?.document_row_type === webSiteStore.documentRowTypeEnum.COMMENT

  const clearCommentRowPricingCell = (e) => {
    if (e.rowType === 'data' && isCommentRow(e.data) && COMMENT_ROW_PRICING_FIELDS.includes(e.column?.dataField)) {
      e.cellElement.textContent = ''
    }
  }

  return { isCommentRow, clearCommentRowPricingCell, COMMENT_ROW_PRICING_FIELDS }
}
